import { mountApplications } from '~/wikis/show';
import { mountMoreActions } from '~/wikis/more_actions';

mountApplications();
mountMoreActions();
